// extracted by mini-css-extract-plugin
module.exports = {"alarmsForVessel":"styles_alarmsForVessel__1Bb5_","alarmCard":"styles_alarmCard__2tZsf","body":"styles_body__xV3M6","icon":"styles_icon__3nTVc","name":"styles_name__37p1n"};